export const RECORD_HISTORY_LOAD = 'RECORD_HISTORY_LOAD'
export interface HistoryLoadPayload {
  type: typeof RECORD_HISTORY_LOAD
  accountId: string
  projectId: string
  moduleName: string
  recordId: string
}

export const loadHistory = (
  accountId: string,
  projectId: string,
  moduleName: string,
  recordId: string
): HistoryLoadPayload => {
  return {
    type: RECORD_HISTORY_LOAD,
    accountId,
    projectId,
    moduleName,
    recordId
  }
}

export const RECORD_HISTORY_LOAD_SUCCESS = 'RECORD_HISTORY_LOAD_SUCCESS'
interface HistoryLoadSuccessPayload {
  type: typeof RECORD_HISTORY_LOAD_SUCCESS
  record: Record<string, any>[]
}

export const loadHistorySuccess = (
  record: Record<string, any>[]
): HistoryLoadSuccessPayload => {
  return {
    type: RECORD_HISTORY_LOAD_SUCCESS,
    record
  }
}

export const RECORD_HISTORY_LOAD_FAILURE = 'RECORD_HISTORY_LOAD_FAILURE'
interface HistoryLoadFailurePayload {
  type: typeof RECORD_HISTORY_LOAD_FAILURE
  error: Error
}

export const loadHistoryFailure = (error: Error): HistoryLoadFailurePayload => {
  return {
    type: RECORD_HISTORY_LOAD_FAILURE,
    error
  }
}
